import { render, staticRenderFns } from "./ModalDaylightSaving.vue?vue&type=template&id=366be1ea&scoped=true"
import script from "./ModalDaylightSaving.vue?vue&type=script&lang=js"
export * from "./ModalDaylightSaving.vue?vue&type=script&lang=js"
import style0 from "./ModalDaylightSaving.vue?vue&type=style&index=0&id=366be1ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366be1ea",
  null
  
)

export default component.exports